import RenderHtml from "../../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml";

const GenerateStepPreview = ({ stepDetails }) => {
  // Ensure stepDetails is an array before processing
  if (!stepDetails || !Array.isArray(stepDetails) || stepDetails.length === 0) {
    return null;
  }

  return (
    <p>
      {structuredClone(stepDetails)
        ?.sort((a, b) => {
          const dateA = a?.created_at ? new Date(a.created_at).getTime() : (a?.orders ?? 0);
          const dateB = b?.created_at ? new Date(b.created_at).getTime() : (b?.orders ?? 0);
          if (typeof dateA === "number" && typeof dateB === "number") return dateA - dateB;
          return 0;
        })
        .map((myStep, index) => {
          const partNumber = myStep?.partNumber ?? myStep?.part_info?.part_number ?? "";
          const description = myStep?.description ?? myStep?.part_info?.description ?? "";
          const qtyText =
            myStep?.qty && myStep.qty !== 0 ? `Qty ${myStep.qty}` : "";

          const partText = partNumber ? ` (${partNumber})` : "";

          return (
            <span key={index}>
              {myStep.action}
              {partText} <RenderHtml content={description} /> {qtyText}&nbsp;
            </span>
          );
        })}
    </p>
  );
};

export default GenerateStepPreview;